import {CHAT_ADMIN, CHAT_ADMIN_SETTINGS} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

/**
 * CHAT_ADMIN's screens, on the standard (Metronic) layout. Both are guarded by the CHAT_ADMIN
 * feature in the route itself, not just the menu: a missing route code means "always allow".
 */
export const ChatAdminRoutes: IAppRoutes[] = [
  {
    link: CHAT_ADMIN,
    element: guard(() => import('@modules/chat-admin/conversations'), [CHAT_ADMIN]),
  },
  {
    link: CHAT_ADMIN_SETTINGS,
    element: guard(() => import('@modules/chat-admin/settings'), [CHAT_ADMIN]),
  },
]
